import api from './api';

const installmentService = {
  list: async () => {
    const res = await api.get('/installments');
    return res.data;
  },

  get: async (id: string) => {
    const res = await api.get(`/installments/${id}`);
    return res.data;
  },

  create: async (payload: any) => {
    const res = await api.post('/installments', payload);
    return res.data;
  },

  update: async (id: string, payload: any) => {
    const res = await api.put(`/installments/${id}`, payload);
    return res.data;
  },

  remove: async (id: string) => {
    const res = await api.delete(`/installments/${id}`);
    return res.data;
  },
};

export default installmentService;
